(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar {
    constructor() {
      this.bar = document.querySelector('[data-announcement-bar]')
      this.messages = document.querySelectorAll('[data-announcement-message]')
      this.closeBtn = document.querySelector('[data-announcement-close]')
      this.currentIndex = 0
      this.interval = null

      if (!this.bar || this.messages.length <= 1) return

      this.autoRotate = this.bar.style.getPropertyValue('--rotation-duration') !== null
      this.rotationSpeed = parseInt(this.bar.style.getPropertyValue('--rotation-duration')) || 5

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close())
        this.checkClosed()
      }

      if (this.autoRotate && this.messages.length > 1) {
        this.startRotation()
        this.bar.addEventListener('mouseenter', () => this.pauseRotation())
        this.bar.addEventListener('mouseleave', () => this.startRotation())
      }
    }

    startRotation() {
      if (this.interval) return
      this.interval = setInterval(() => this.rotate(), this.rotationSpeed * 1000)
    }

    pauseRotation() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    }

    rotate() {
      this.messages[this.currentIndex].classList.remove('is-active')
      this.currentIndex = (this.currentIndex + 1) % this.messages.length
      this.messages[this.currentIndex].classList.add('is-active')
    }

    close() {
      this.bar.classList.add('is-hidden')
      try {
        localStorage.setItem('announcementBarClosed', 'true')
      } catch (e) {}
    }

    checkClosed() {
      try {
        if (localStorage.getItem('announcementBarClosed') === 'true') {
          this.bar.classList.add('is-hidden')
        }
      } catch (e) {}
    }
  }

  new AnnouncementBar()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('[data-blog-slider]');
    
    sliders.forEach(slider => {
      const viewport = slider.querySelector('[data-slider-viewport]');
      const track = slider.querySelector('[data-slider-track]');
      const slides = slider.querySelectorAll('[data-slide]');
      const progressBar = slider.querySelector('[data-progress-bar]');
      
      if (slides.length === 0) return;

      let isDragging = false;
      let startX = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID = 0;
      let autoplayInterval = null;
      let autoplayPaused = false;
      let dragDistance = 0;
      let wasDragged = false;
      const dragThreshold = 10;
      
      const autoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) * 1000;

      function getSlideWidth() {
        if (slides.length === 0) return 0;
        const slideStyle = window.getComputedStyle(slides[0]);
        const gap = parseInt(window.getComputedStyle(track).gap) || 24;
        return slides[0].offsetWidth + gap;
      }

      function getMaxTranslate() {
        const trackWidth = track.scrollWidth;
        const viewportWidth = viewport.offsetWidth;
        return Math.max(0, trackWidth - viewportWidth);
      }

      function updateProgress() {
        const maxTranslate = getMaxTranslate();
        if (maxTranslate > 0) {
          const progress = Math.abs(currentTranslate) / maxTranslate * 100;
          progressBar.style.width = Math.min(100, progress) + '%';
        } else {
          progressBar.style.width = '100%';
        }
      }

      function setSliderPosition() {
        track.style.transform = `translateX(${currentTranslate}px)`;
        updateProgress();
      }

      function animation() {
        setSliderPosition();
        if (isDragging) {
          animationID = requestAnimationFrame(animation);
        }
      }

      function touchStart(event) {
        isDragging = true;
        startX = getPositionX(event);
        dragDistance = 0;
        wasDragged = false;
        track.classList.remove('animating');
        viewport.classList.add('dragging');
        
        animationID = requestAnimationFrame(animation);
        
        stopAutoplay();
      }

      function touchMove(event) {
        if (!isDragging) return;
        
        const currentPosition = getPositionX(event);
        const diff = currentPosition - startX;
        dragDistance = Math.abs(diff);
        
        const newTranslate = prevTranslate + diff;
        
        const maxTranslate = getMaxTranslate();
        const resistance = 0.3;
        
        if (newTranslate > 0) {
          currentTranslate = newTranslate * resistance;
        } else if (Math.abs(newTranslate) > maxTranslate) {
          const overflow = Math.abs(newTranslate) - maxTranslate;
          currentTranslate = -maxTranslate - (overflow * resistance);
        } else {
          currentTranslate = newTranslate;
        }
      }

      function touchEnd() {
        if (!isDragging) return;
        
        wasDragged = dragDistance > dragThreshold;
        isDragging = false;
        cancelAnimationFrame(animationID);
        viewport.classList.remove('dragging');
        track.classList.add('animating');
        
        const maxTranslate = getMaxTranslate();
        
        if (currentTranslate > 0) {
          currentTranslate = 0;
        } else if (Math.abs(currentTranslate) > maxTranslate) {
          currentTranslate = -maxTranslate;
        }
        
        prevTranslate = currentTranslate;
        setSliderPosition();
        
        if (autoplay && !autoplayPaused) {
          startAutoplay();
        }
      }

      function getPositionX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      }

      function autoSlide() {
        const slideWidth = getSlideWidth();
        const maxTranslate = getMaxTranslate();
        
        if (Math.abs(currentTranslate) >= maxTranslate - 10) {
          currentTranslate = 0;
        } else {
          currentTranslate = currentTranslate - slideWidth;
          if (Math.abs(currentTranslate) > maxTranslate) {
            currentTranslate = -maxTranslate;
          }
        }
        
        prevTranslate = currentTranslate;
        track.classList.add('animating');
        setSliderPosition();
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        autoplayInterval = setInterval(autoSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      viewport.addEventListener('mousedown', touchStart);
      viewport.addEventListener('mousemove', touchMove);
      viewport.addEventListener('mouseup', touchEnd);
      viewport.addEventListener('mouseleave', touchEnd);
      
      viewport.addEventListener('touchstart', touchStart, { passive: true });
      viewport.addEventListener('touchmove', touchMove, { passive: true });
      viewport.addEventListener('touchend', touchEnd);
      
      viewport.addEventListener('dragstart', (e) => e.preventDefault());

      track.addEventListener('click', (e) => {
        if (wasDragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);

      if (autoplay) {
        startAutoplay();
        
        slider.addEventListener('mouseenter', () => {
          autoplayPaused = true;
          stopAutoplay();
        });
        
        slider.addEventListener('mouseleave', () => {
          autoplayPaused = false;
          if (!isDragging) {
            startAutoplay();
          }
        });
      }

      window.addEventListener('resize', () => {
        const maxTranslate = getMaxTranslate();
        if (Math.abs(prevTranslate) > maxTranslate) {
          currentTranslate = -maxTranslate;
          prevTranslate = currentTranslate;
          track.classList.add('animating');
          setSliderPosition();
        }
        updateProgress();
      });

      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

    connectedCallback() {
      this.fetchRecommendations();
    }

    bindEvents() {
      this.itemsContainer = this.querySelector('#cart-page-items');
      this.updateBtn = this.querySelector('.cart-page__update');

      if (this.updateBtn) {
        this.updateBtn.style.display = 'none';
      }

      if (this.itemsContainer && !this.itemsContainer.hasAttribute('data-bound')) {
        this.itemsContainer.setAttribute('data-bound', 'true');
        this.itemsContainer.addEventListener('click', (e) => this.handleItemClick(e));
        this.itemsContainer.addEventListener('change', (e) => this.handleItemChange(e));
      }

      if (!this.hasAttribute('data-quick-add-bound')) {
        this.setAttribute('data-quick-add-bound', 'true');
        this.addEventListener('click', (e) => {
          const quickAddBtn = e.target.closest('[data-quick-add]');
          if (quickAddBtn) {
            e.preventDefault();
            const formData = new FormData();
            formData.append('id', quickAddBtn.dataset.quickAdd);
            formData.append('quantity', 1);
            window.CartUtils.addItem(formData);
          }
        });
      }

      const noteInput = this.querySelector('.cart-page__note-input');
      if (noteInput && !noteInput.hasAttribute('data-bound')) {
        noteInput.setAttribute('data-bound', 'true');
        let noteTimeout;
        noteInput.addEventListener('input', (e) => {
          clearTimeout(noteTimeout);
          noteTimeout = setTimeout(() => this.updateNote(e.target.value), 500);
        });
      }
    }

    handleItemClick(e) {
      const minusBtn = e.target.closest('[data-qty-minus]');
      const plusBtn = e.target.closest('[data-qty-plus]');

      if (minusBtn) {
        const item = minusBtn.closest('.cart-page__item');
        const input = item.querySelector('[data-qty-input]');
        const newQty = parseInt(input.value) - 1;
        if (newQty >= 0) {
          this.updateItem(item.dataset.itemKey, newQty);
        }
      } else if (plusBtn) {
        const item = plusBtn.closest('.cart-page__item');
        const input = item.querySelector('[data-qty-input]');
        const newQty = parseInt(input.value) + 1;
        this.updateItem(item.dataset.itemKey, newQty);
      }
    }

    handleItemChange(e) {
      if (e.target.matches('[data-qty-input]')) {
        const item = e.target.closest('.cart-page__item');
        const newQty = parseInt(e.target.value);
        if (newQty >= 0) {
          this.updateItem(item.dataset.itemKey, newQty);
        }
      }
    }

    async updateItem(key, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: key, quantity }),
        });

        const cart = await response.json();
        this.refresh();
        window.publish('cart:item-updated', { cart });
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async updateNote(note) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note }),
        });
      } catch (error) {
        console.error('Error updating note:', error);
      }
    }

    async refresh() {
      try {
        const response = await fetch('/cart?section_id=cart');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContainer = doc.querySelector('.cart-page__container');
        const currentContainer = this.querySelector('.cart-page__container');

        if (newContainer && currentContainer) {
          const isEmpty = newContainer.querySelector('.cart-page__empty');
          if (isEmpty) {
            this.classList.add('is-empty');
          } else {
            this.classList.remove('is-empty');
          }
          currentContainer.innerHTML = newContainer.innerHTML;
          this.bindEvents();
        }

        this.updateCartBubble();
        this.fetchRecommendations();
      } catch (error) {
        console.error('Error refreshing cart page:', error);
      }
    }

    async fetchRecommendations() {
      const container = this.querySelector('[data-cart-recommendations]');
      if (!container) return;

      const url = container.dataset.url;
      if (!url) return;

      const list = container.querySelector('.cart-page__recommendations-list');
      if (!list) return;

      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-recommendations-content]');
        if (content) {
          list.innerHTML = content.innerHTML;
          container.style.display = '';
        }
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    }

    async updateCartBubble() {
      try {
        const response = await fetch('/cart?section_id=cart-icon-bubble');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble');
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && cartBubble) {
          cartBubble.outerHTML = newBubble.outerHTML;
        }
      } catch (error) {
        console.error('Error updating cart bubble:', error);
      }
    }
  }

  customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cocoa-origin"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-cocoa-origin]').forEach(function(section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';

      var map = section.querySelector('[data-country-map]');
      var mapWrapper = section.querySelector('[data-origin-map]');

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            triggerAnimations();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      observer.observe(section);

      function triggerAnimations() {
        if (map) {
          setTimeout(function() { map.classList.add('animate'); }, 200);
        }

        section.querySelectorAll('.cocoa-origin__animate').forEach(function(el) {
          el.classList.add('visible');
        });
      }

      if (window.matchMedia('(min-width: 1024px)').matches) {
        section.addEventListener('mousemove', function(e) {
          if (!mapWrapper) return;
          var rect = section.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          mapWrapper.style.transform = 'perspective(800px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
        });

        section.addEventListener('mouseleave', function() {
          if (!mapWrapper) return;
          mapWrapper.style.transition = 'transform 0.6s ease';
          mapWrapper.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg)';
          setTimeout(function() { mapWrapper.style.transition = ''; }, 600);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-all"]) return;
  try {
    
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });
  }

  const filterSelect = document.querySelector('[data-filter-select]');
  if (filterSelect) {
    filterSelect.addEventListener('change', (e) => {
      if (e.target.value) {
        window.location.href = e.target.value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });
  }

  const filterSelect = document.querySelector('[data-filter-select]');
  if (filterSelect) {
    filterSelect.addEventListener('change', (e) => {
      if (e.target.value) {
        window.location.href = e.target.value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('.customer-reviews__carousel');

    carousels.forEach(function(carousel) {
      var section = carousel.closest('.customer-reviews');
      var allSlides = carousel.querySelectorAll('.customer-reviews__item');
      var realSlides = carousel.querySelectorAll('.customer-reviews__item:not(.customer-reviews__item--clone)');
      var slideCount = realSlides.length;
      var track = carousel.querySelector('.customer-reviews__track');
      var viewport = carousel.querySelector('.customer-reviews__viewport');
      var dots = carousel.querySelectorAll('.customer-reviews__dot');
      var prevBtn = carousel.querySelector('.customer-reviews__arrow--prev');
      var nextBtn = carousel.querySelector('.customer-reviews__arrow--next');
      var autoplayInterval = null;

      var isDragging = false;
      var startX = 0;
      var currentX = 0;
      var dragOffset = 0;

      if (slideCount <= 1) return;

      var currentIndex = 1;
      var totalSlides = allSlides.length;

      function goTo(index, smooth) {
        if (smooth === undefined) smooth = true;
        track.style.transition = smooth ? 'transform 0.6s ease-out' : 'none';
        track.style.transform = 'translateX(-' + (index * 100) + '%)';

        if (smooth) {
          track.addEventListener('transitionend', function handler() {
            track.removeEventListener('transitionend', handler);

            if (index === 0) {
              currentIndex = totalSlides - 2;
              track.style.transition = 'none';
              track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
            } else if (index === totalSlides - 1) {
              currentIndex = 1;
              track.style.transition = 'none';
              track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
            }

            updateDots();
          });
        } else {
          currentIndex = index;
          updateDots();
        }
      }

      function next() {
        currentIndex++;
        goTo(currentIndex);
      }

      function prev() {
        currentIndex--;
        goTo(currentIndex);
      }

      function goToSlide(index) {
        currentIndex = index + 1;
        goTo(currentIndex);
      }

      function updateDots() {
        var realIndex = currentIndex === 0 ? slideCount - 1 :
                        currentIndex === totalSlides - 1 ? 0 :
                        currentIndex - 1;
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === realIndex);
        });
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        var speed = parseInt(carousel.dataset.autoplaySpeed, 10) * 1000;
        autoplayInterval = setInterval(next, speed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function handleDragStart(e) {
        isDragging = true;
        viewport.classList.add('dragging');
        startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        currentX = startX;
        stopAutoplay();
        track.style.transition = 'none';
      }

      function handleDragMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        dragOffset = currentX - startX;
        var baseOffset = currentIndex * -100;
        var dragPercent = (dragOffset / viewport.offsetWidth) * 100;
        track.style.transform = 'translateX(' + (baseOffset + dragPercent) + '%)';
      }

      function handleDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('dragging');
        var threshold = viewport.offsetWidth * 0.2;

        if (dragOffset > threshold) {
          currentIndex--;
        } else if (dragOffset < -threshold) {
          currentIndex++;
        }

        goTo(currentIndex);
        dragOffset = 0;

        if (carousel.dataset.autoplay === 'true') {
          startAutoplay();
        }
      }

      prevBtn.addEventListener('click', prev);
      nextBtn.addEventListener('click', next);

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goToSlide(i); });
      });

      viewport.addEventListener('mousedown', handleDragStart);
      viewport.addEventListener('mousemove', handleDragMove);
      viewport.addEventListener('mouseup', handleDragEnd);
      viewport.addEventListener('mouseleave', handleDragEnd);

      viewport.addEventListener('touchstart', handleDragStart, { passive: true });
      viewport.addEventListener('touchmove', handleDragMove, { passive: false });
      viewport.addEventListener('touchend', handleDragEnd);

      viewport.addEventListener('dragstart', function(e) { e.preventDefault(); });

      if (carousel.dataset.autoplay === 'true') {
        startAutoplay();
        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
      }

      section.setAttribute('tabindex', '0');
      section.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') { prev(); }
        else if (e.key === 'ArrowRight') { next(); }
      });

      updateDots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SearchDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-search-drawer]')
      this.toggleBtn = document.querySelector('[data-search-toggle]')
      this.closeBtns = document.querySelectorAll('[data-search-close]')
      this.input = document.querySelector('[data-search-input]')
      this.resultsContainer = document.querySelector('[data-search-results-list]')
      this.resultsWrapper = document.querySelector('[data-search-results]')
      this.viewAllBtn = document.querySelector('[data-search-view-all]')
      this.debounceTimer = null
      this.currentQuery = ''

      if (this.toggleBtn && this.drawer) {
        this.toggleBtn.addEventListener('click', () => this.open())
        this.closeBtns.forEach(btn => btn.addEventListener('click', () => this.close()))
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close()
        })
      }

      if (this.input) {
        this.input.addEventListener('input', (e) => this.handleInput(e))
      }
    }

    open() {
      this.drawer.classList.add('is-open')
      this.drawer.setAttribute('aria-hidden', 'false')
      document.body.style.overflow = 'hidden'
      const input = this.drawer.querySelector('input')
      if (input) setTimeout(() => input.focus(), 100)
    }

    close() {
      this.drawer.classList.remove('is-open')
      this.drawer.setAttribute('aria-hidden', 'true')
      document.body.style.overflow = ''
    }

    handleInput(e) {
      const query = e.target.value.trim()
      
      if (query === this.currentQuery) return
      this.currentQuery = query

      clearTimeout(this.debounceTimer)

      if (query.length < 2) {
        this.clearResults()
        return
      }

      this.debounceTimer = setTimeout(() => {
        this.fetchResults(query)
      }, 300)
    }

    async fetchResults(query) {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6`)
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const data = await response.json()
        this.renderResults(data, query)
      } catch (error) {
        console.error('Search error:', error)
        this.resultsContainer.innerHTML = `<div class="search-drawer__error">${this.getTranslation('searchError')}</div>`
        this.viewAllBtn.classList.add('hidden')
      }
    }

    getTranslation(key) {
      return this.resultsWrapper?.dataset[key] || key
    }

    renderResults(data, query) {
      const resources = data.resources.results
      const products = resources.products || []
      const articles = resources.articles || []
      const pages = resources.pages || []
      const allResults = [...products, ...articles, ...pages]

      this.resultsContainer.innerHTML = ''

      if (allResults.length === 0) {
        this.resultsContainer.innerHTML = `<div class="search-drawer__no-results">${this.getTranslation('noResults')}</div>`
        this.viewAllBtn.classList.add('hidden')
        return
      }

      allResults.forEach(result => {
        const isProduct = result.type === 'product' || result.available !== undefined
        const imageUrl = result.featured_image?.url || result.image || ''
        const price = isProduct && result.price ? this.formatMoney(parseFloat(result.price)) : ''
        const typeLabel = isProduct ? this.getTranslation('product') : result.type === 'article' ? this.getTranslation('article') : this.getTranslation('page')

        const resultEl = document.createElement('a')
        resultEl.href = result.url
        resultEl.className = 'search-drawer__result'
        resultEl.innerHTML = `
          ${imageUrl ? `
            <div class="search-drawer__result-image">
              <img src="${imageUrl}" alt="${result.title || ''}" loading="lazy">
            </div>
          ` : ''}
          <div class="search-drawer__result-content">
            <p class="search-drawer__result-title">${result.title}</p>
            ${price ? `<p class="search-drawer__result-price">${price}</p>` : ''}
            <p class="search-drawer__result-type">${typeLabel}</p>
          </div>
        `
        this.resultsContainer.appendChild(resultEl)
      })

      this.viewAllBtn.href = `/search?q=${encodeURIComponent(query)}`
      this.viewAllBtn.classList.remove('hidden')
    }

    clearResults() {
      this.resultsContainer.innerHTML = ''
      this.viewAllBtn.classList.add('hidden')
    }

    formatMoney(amount) {
      const locale = this.searchWrapper?.dataset.locale || 'en-GB'
      const currency = this.searchWrapper?.dataset.currency || 'GBP'
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount)
    }
  }

  class StickyHeader {
    constructor() {
      this.header = document.querySelector('[data-header]')
      if (this.header && this.header.classList.contains('header--sticky')) {
        this.handleScroll()
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true })
      }
    }

    handleScroll() {
      if (window.scrollY > 10) {
        this.header.classList.add('is-scrolled')
      } else {
        this.header.classList.remove('is-scrolled')
      }
    }
  }

  class MobileMenu {
    constructor() {
      this.menu = document.querySelector('[data-mobile-menu]')
      this.toggleBtn = document.querySelector('[data-mobile-menu-toggle]')
      this.closeBtns = document.querySelectorAll('[data-mobile-menu-close]')
      this.links = document.querySelectorAll('[data-mobile-menu-link]')

      if (this.toggleBtn && this.menu) {
        this.toggleBtn.addEventListener('click', () => this.toggle())
        this.closeBtns.forEach(btn => btn.addEventListener('click', () => this.close()))
        this.links.forEach(link => link.addEventListener('click', () => this.close()))
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close()
        })
      }
    }

    toggle() {
      if (this.menu.classList.contains('is-open')) {
        this.close()
      } else {
        this.open()
      }
    }

    open() {
      this.menu.classList.add('is-open')
      this.menu.setAttribute('aria-hidden', 'false')
      this.toggleBtn.classList.add('is-open')
      this.toggleBtn.setAttribute('aria-expanded', 'true')
      this.toggleBtn.setAttribute('aria-label', this.toggleBtn.getAttribute('aria-label').replace('Open', 'Close'))
      document.body.style.overflow = 'hidden'
    }

    close() {
      this.menu.classList.remove('is-open')
      this.menu.setAttribute('aria-hidden', 'true')
      this.toggleBtn.classList.remove('is-open')
      this.toggleBtn.setAttribute('aria-expanded', 'false')
      this.toggleBtn.setAttribute('aria-label', this.toggleBtn.getAttribute('aria-label').replace('Close', 'Open'))
      document.body.style.overflow = ''
    }
  }

  class MobileMenuAccordion {
    constructor() {
      this.items = document.querySelectorAll('[data-mobile-menu-item]')
      if (this.items.length) {
        this.init()
      }
    }

    init() {
      this.items.forEach(item => {
        const toggle = item.querySelector('[data-mobile-menu-toggle]')
        if (toggle) {
          toggle.addEventListener('click', (e) => {
            e.preventDefault()
            this.toggleItem(item)
          })
        }
      })
    }

    toggleItem(item) {
      const isOpen = item.classList.contains('is-open')
      const toggle = item.querySelector('[data-mobile-menu-toggle]')
      
      if (isOpen) {
        item.classList.remove('is-open')
        toggle.setAttribute('aria-expanded', 'false')
      } else {
        item.classList.add('is-open')
        toggle.setAttribute('aria-expanded', 'true')
      }
    }
  }

  new MobileMenu()
  new MobileMenuAccordion()
  new SearchDrawer()
  new StickyHeader()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('.hero-slider');
    
    sliders.forEach(slider => {
      const allSlides = slider.querySelectorAll('.hero-slider__slide');
      const realSlides = slider.querySelectorAll('.hero-slider__slide:not(.hero-slider__slide--clone)');
      const slideCount = realSlides.length;
      const track = slider.querySelector('.hero-slider__track');
      const viewport = slider.querySelector('.hero-slider__viewport');
      const dots = slider.querySelectorAll('.hero-slider__dot');
      const prevBtn = slider.querySelector('.hero-slider__arrow--prev');
      const nextBtn = slider.querySelector('.hero-slider__arrow--next');
      let autoplayInterval = null;

      let isDragging = false;
      let startX = 0;
      let currentX = 0;
      let dragOffset = 0;

      if (slideCount <= 1) return;

      let currentIndex = 1;
      const totalSlides = allSlides.length;

      function goTo(index, smooth = true) {
        track.style.transition = smooth ? 'transform 0.6s ease-out' : 'none';
        track.style.transform = `translateX(-${index * 100}%)`;
        
        if (smooth) {
          track.addEventListener('transitionend', function handler() {
            track.removeEventListener('transitionend', handler);
            
            if (index === 0) {
              currentIndex = totalSlides - 2;
              track.style.transition = 'none';
              track.style.transform = `translateX(-${currentIndex * 100}%)`;
            } else if (index === totalSlides - 1) {
              currentIndex = 1;
              track.style.transition = 'none';
              track.style.transform = `translateX(-${currentIndex * 100}%)`;
            }
            
            updateDots();
          });
        } else {
          currentIndex = index;
          updateDots();
        }
      }

      function next() {
        currentIndex++;
        goTo(currentIndex);
      }

      function prev() {
        currentIndex--;
        goTo(currentIndex);
      }

      function goToSlide(index) {
        currentIndex = index + 1;
        goTo(currentIndex);
      }

      function updateDots() {
        const realIndex = currentIndex === 0 ? slideCount - 1 : 
                          currentIndex === totalSlides - 1 ? 0 : 
                          currentIndex - 1;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === realIndex);
        });
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        const speed = parseInt(slider.dataset.autoplaySpeed, 10) * 1000;
        autoplayInterval = setInterval(next, speed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function handleDragStart(e) {
        isDragging = true;
        viewport.classList.add('dragging');
        startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        currentX = startX;
        stopAutoplay();
        track.style.transition = 'none';
      }

      function handleDragMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        dragOffset = currentX - startX;
        const baseOffset = currentIndex * -100;
        const dragPercent = (dragOffset / viewport.offsetWidth) * 100;
        track.style.transform = `translateX(${baseOffset + dragPercent}%)`;
      }

      function handleDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('dragging');
        const threshold = viewport.offsetWidth * 0.2;
        
        if (dragOffset > threshold) {
          currentIndex--;
        } else if (dragOffset < -threshold) {
          currentIndex++;
        }
        
        goTo(currentIndex);
        dragOffset = 0;
        
        if (slider.dataset.autoplay === 'true') {
          startAutoplay();
        }
      }

      prevBtn.addEventListener('click', prev);
      nextBtn.addEventListener('click', next);

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => goToSlide(i));
      });

      viewport.addEventListener('mousedown', handleDragStart);
      viewport.addEventListener('mousemove', handleDragMove);
      viewport.addEventListener('mouseup', handleDragEnd);
      viewport.addEventListener('mouseleave', handleDragEnd);

      viewport.addEventListener('touchstart', handleDragStart, { passive: true });
      viewport.addEventListener('touchmove', handleDragMove, { passive: false });
      viewport.addEventListener('touchend', handleDragEnd);

      viewport.addEventListener('dragstart', (e) => e.preventDefault());

      if (slider.dataset.autoplay === 'true') {
        startAutoplay();
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
      }

      slider.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          prev();
        } else if (e.key === 'ArrowRight') {
          next();
        }
      });

      slider.setAttribute('role', 'region');
      slider.setAttribute('aria-label', 'Image carousel');
      slider.setAttribute('tabindex', '0');

      track.style.transition = '';

      updateDots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["islands-promise"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-islands-promise]');
    if (!section) return;

    var sectionId = section.dataset.islandsPromise;
    var navEl = section.querySelector('.islands-promise__nav');
    var header = document.querySelector('[data-header]');

    function getHeaderHeight() {
      return header ? header.offsetHeight : 0;
    }

    function updateNavTop() {
      if (navEl) {
        navEl.style.top = getHeaderHeight() + 'px';
      }
    }

    updateNavTop();
    window.addEventListener('scroll', updateNavTop, { passive: true });
    window.addEventListener('resize', updateNavTop, { passive: true });

    function getNavHeight() {
      return navEl ? navEl.offsetHeight : 0;
    }

    var navItems = section.querySelectorAll('[data-promise-nav]');
    var cards = [];
    navItems.forEach(function(item) {
      var card = document.getElementById(item.dataset.promiseNav);
      if (card) cards.push({ nav: item, card: card });
    });

    navItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var target = document.getElementById(item.dataset.promiseNav);
        if (target) {
          var offset = getHeaderHeight() + getNavHeight();
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    if (cards.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var match = cards.find(function(c) { return c.card === entry.target; });
          if (match) {
            if (entry.isIntersecting) {
              cards.forEach(function(c) { c.nav.classList.remove('is-active'); });
              match.nav.classList.add('is-active');
            }
          }
        });
      }, {
        rootMargin: '-30% 0px -60% 0px',
        threshold: 0
      });

      cards.forEach(function(c) { observer.observe(c.card); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window._story2ParallaxInitialized) return;
    window._story2ParallaxInitialized = true;

    /* data-parallax="start,end" — px offsets mapped linearly over the figure's
       journey through the viewport (0 entering → 1 leaving), UIkit-style.
       Halved on small screens so mobile stays tame. All images inside a
       figure share one offset. Only the collage figures use it — the band
       background is static (client pin). */

    var items = [];
    var ticking = false;

    function collect(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.story2:not([data-parallax-ready])');
      for (var s = 0; s < sections.length; s++) {
        sections[s].setAttribute('data-parallax-ready', '');
        var figures = sections[s].querySelectorAll('[data-parallax]');
        for (var i = 0; i < figures.length; i++) {
          var range = figures[i].getAttribute('data-parallax').split(',');
          items.push({
            figure: figures[i],
            imgs: figures[i].querySelectorAll('img'),
            start: parseFloat(range[0]) || 0,
            end: parseFloat(range[1]) || 0
          });
        }
      }
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var factor = window.matchMedia('(max-width: 767px)').matches ? 0.5 : 1;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].figure.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) continue;
        var t = (vh - rect.top) / (vh + rect.height);
        if (t < 0) t = 0; else if (t > 1) t = 1;
        var y = (items[i].start + (items[i].end - items[i].start) * t) * factor;
        for (var j = 0; j < items[i].imgs.length; j++) {
          items[i].imgs[j].style.transform = 'translate3d(0, ' + y.toFixed(1) + 'px, 0)';
        }
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function init() {
      collect();
      if (!items.length) return;
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    /* Product scroller: mouse drag-to-scroll + click suppression after a
       drag — ported from the blog/recipe slider. */
    var track = document.querySelector('.story2__scroller-track');
    if (!track) return;

    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragged = false;

    track.addEventListener('mousedown', function (e) {
      dragging = true;
      dragged = false;
      dragStartX = e.pageX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var delta = e.pageX - dragStartX;
      if (Math.abs(delta) > 5) dragged = true;
      track.scrollLeft = dragStartScroll - delta;
    });

    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window._ourStoryParallaxInitialized) return;
    window._ourStoryParallaxInitialized = true;

    /* data-parallax="start,end" — px offsets mapped linearly over the figure's
       journey through the viewport (0 entering → 1 leaving), UIkit-style
       (y: a,b; easing: 1). Halved on small screens so mobile stays tame. */

    var items = [];
    var ticking = false;

    function collect(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('.our-story:not([data-parallax-ready])');
      for (var s = 0; s < sections.length; s++) {
        sections[s].setAttribute('data-parallax-ready', '');
        var figures = sections[s].querySelectorAll('.our-story__collage figure[data-parallax]');
        for (var i = 0; i < figures.length; i++) {
          var range = figures[i].getAttribute('data-parallax').split(',');
          items.push({
            figure: figures[i],
            img: figures[i].querySelector('img'),
            start: parseFloat(range[0]) || 0,
            end: parseFloat(range[1]) || 0
          });
        }
      }
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var factor = window.matchMedia('(max-width: 767px)').matches ? 0.5 : 1;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].figure.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) continue;
        var t = (vh - rect.top) / (vh + rect.height);
        if (t < 0) t = 0; else if (t > 1) t = 1;
        var y = (items[i].start + (items[i].end - items[i].start) * t) * factor;
        items[i].img.style.transform = 'translate3d(0, ' + y.toFixed(1) + 'px, 0)';
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function init() {
      collect();
      if (!items.length) return;
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recipes"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('[data-product-recipes]');
    
    sliders.forEach(slider => {
      const viewport = slider.querySelector('[data-slider-viewport]');
      const track = slider.querySelector('[data-slider-track]');
      const slides = slider.querySelectorAll('[data-slide]');
      const progressBar = slider.querySelector('[data-progress-bar]');
      
      if (slides.length === 0) return;

      let isDragging = false;
      let startX = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID = 0;
      let autoplayInterval = null;
      let autoplayPaused = false;
      let dragDistance = 0;
      let wasDragged = false;
      const dragThreshold = 10;
      
      const autoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) * 1000;

      function getSlideWidth() {
        if (slides.length === 0) return 0;
        const slideStyle = window.getComputedStyle(slides[0]);
        const gap = parseInt(window.getComputedStyle(track).gap) || 24;
        return slides[0].offsetWidth + gap;
      }

      function getMaxTranslate() {
        const trackWidth = track.scrollWidth;
        const viewportWidth = viewport.offsetWidth;
        return Math.max(0, trackWidth - viewportWidth);
      }

      function updateProgress() {
        const maxTranslate = getMaxTranslate();
        if (maxTranslate > 0) {
          const progress = Math.abs(currentTranslate) / maxTranslate * 100;
          progressBar.style.width = Math.min(100, progress) + '%';
        } else {
          progressBar.style.width = '100%';
        }
      }

      function setSliderPosition() {
        track.style.transform = `translateX(${currentTranslate}px)`;
        updateProgress();
      }

      function animation() {
        setSliderPosition();
        if (isDragging) {
          animationID = requestAnimationFrame(animation);
        }
      }

      function touchStart(event) {
        isDragging = true;
        startX = getPositionX(event);
        dragDistance = 0;
        wasDragged = false;
        track.classList.remove('animating');
        viewport.classList.add('dragging');
        
        animationID = requestAnimationFrame(animation);
        
        stopAutoplay();
      }

      function touchMove(event) {
        if (!isDragging) return;
        
        const currentPosition = getPositionX(event);
        const diff = currentPosition - startX;
        dragDistance = Math.abs(diff);
        
        const newTranslate = prevTranslate + diff;
        
        const maxTranslate = getMaxTranslate();
        const resistance = 0.3;
        
        if (newTranslate > 0) {
          currentTranslate = newTranslate * resistance;
        } else if (Math.abs(newTranslate) > maxTranslate) {
          const overflow = Math.abs(newTranslate) - maxTranslate;
          currentTranslate = -maxTranslate - (overflow * resistance);
        } else {
          currentTranslate = newTranslate;
        }
      }

      function touchEnd() {
        if (!isDragging) return;
        
        wasDragged = dragDistance > dragThreshold;
        isDragging = false;
        cancelAnimationFrame(animationID);
        viewport.classList.remove('dragging');
        track.classList.add('animating');
        
        const maxTranslate = getMaxTranslate();
        
        if (currentTranslate > 0) {
          currentTranslate = 0;
        } else if (Math.abs(currentTranslate) > maxTranslate) {
          currentTranslate = -maxTranslate;
        }
        
        prevTranslate = currentTranslate;
        setSliderPosition();
        
        if (autoplay && !autoplayPaused) {
          startAutoplay();
        }
      }

      function getPositionX(event) {
        if (event.type.includes('mouse')) return event.pageX;
        return event.touches && event.touches[0] ? event.touches[0].clientX : 0;
      }

      function autoSlide() {
        const slideWidth = getSlideWidth();
        const maxTranslate = getMaxTranslate();
        
        if (Math.abs(currentTranslate) >= maxTranslate - 10) {
          currentTranslate = 0;
        } else {
          currentTranslate = currentTranslate - slideWidth;
          if (Math.abs(currentTranslate) > maxTranslate) {
            currentTranslate = -maxTranslate;
          }
        }
        
        prevTranslate = currentTranslate;
        track.classList.add('animating');
        setSliderPosition();
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        autoplayInterval = setInterval(autoSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      viewport.addEventListener('mousedown', touchStart);
      viewport.addEventListener('mousemove', touchMove);
      viewport.addEventListener('mouseup', touchEnd);
      viewport.addEventListener('mouseleave', touchEnd);
      
      viewport.addEventListener('touchstart', touchStart, { passive: true });
      viewport.addEventListener('touchmove', touchMove, { passive: true });
      viewport.addEventListener('touchend', touchEnd);
      
      viewport.addEventListener('dragstart', (e) => e.preventDefault());

      track.addEventListener('click', (e) => {
        if (wasDragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);

      if (autoplay) {
        startAutoplay();
        
        slider.addEventListener('mouseenter', () => {
          autoplayPaused = true;
          stopAutoplay();
        });
        
        slider.addEventListener('mouseleave', () => {
          autoplayPaused = false;
          if (!isDragging) {
            startAutoplay();
          }
        });
      }

      window.addEventListener('resize', () => {
        const maxTranslate = getMaxTranslate();
        if (Math.abs(prevTranslate) > maxTranslate) {
          currentTranslate = -maxTranslate;
          prevTranslate = currentTranslate;
          track.classList.add('animating');
          setSliderPosition();
        }
        updateProgress();
      });

      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[data-product-videos]');

    sections.forEach(section => {
      const cards = section.querySelectorAll('[data-card]');
      const previews = section.querySelectorAll('[data-preview]');
      const dots = section.querySelectorAll('[data-dot]');
      const prevBtn = section.querySelector('[data-prev]');
      const nextBtn = section.querySelector('[data-next]');
      const facades = section.querySelectorAll('[data-facade]');

      if (cards.length === 0) return;

      let currentIndex = 0;
      let autoplayInterval = null;
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) * 1000;

      function updateStack(activeIndex) {
        cards.forEach((card, i) => {
          const relativeIndex = (i - activeIndex + cards.length) % cards.length;
          card.classList.remove('product-videos__card--active');
          card.setAttribute('aria-hidden', 'true');

          if (relativeIndex === 0) {
            card.style.zIndex = 3;
            card.style.transform = 'translateX(0) scale(1)';
            card.style.filter = 'brightness(1)';
            card.classList.add('product-videos__card--active');
            card.setAttribute('aria-hidden', 'false');
          } else if (relativeIndex === 1) {
            card.style.zIndex = 2;
            card.style.transform = 'translateX(60px) scale(0.92)';
            card.style.filter = 'brightness(0.7)';
          } else if (relativeIndex === 2) {
            card.style.zIndex = 1;
            card.style.transform = 'translateX(120px) scale(0.84)';
            card.style.filter = 'brightness(0.5)';
          } else {
            card.style.zIndex = 0;
            card.style.transform = 'translateX(160px) scale(0.76)';
            card.style.filter = 'brightness(0.3)';
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('product-videos__dot--active', i === activeIndex);
        });

        currentIndex = activeIndex;
      }

      function goToSlide(index) {
        if (index < 0) index = cards.length - 1;
        if (index >= cards.length) index = 0;
        updateStack(index);
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        autoplayInterval = setInterval(nextSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function handleFacadeClick(facade) {
        const type = facade.dataset.type;
        const template = facade.nextElementSibling;

        if (!template || template.tagName !== 'TEMPLATE') return;

        const content = template.content.cloneNode(true);

        if (type === 'youtube') {
          const iframe = content.querySelector('iframe');
          if (iframe) {
            facade.replaceWith(iframe);
          }
        } else if (type === 'shopify') {
          const video = content.querySelector('video');
          if (video) {
            facade.replaceWith(video);
          }
        }
      }

      function handlePreviewClick(preview) {
        const targetIndex = parseInt(preview.dataset.index, 10);
        if (!isNaN(targetIndex)) {
          goToSlide(targetIndex);
          stopAutoplay();
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prevSlide();
          stopAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          stopAutoplay();
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          stopAutoplay();
        });
      });

      previews.forEach(preview => {
        preview.addEventListener('click', () => {
          handlePreviewClick(preview);
        });
      });

      facades.forEach(facade => {
        facade.addEventListener('click', () => {
          handleFacadeClick(facade);
          stopAutoplay();
        });
      });

      if (autoplay && cards.length > 1) {
        startAutoplay();

        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('focusin', stopAutoplay);
        section.addEventListener('mouseleave', () => {
          if (!section.matches(':hover')) {
            startAutoplay();
          }
        });
      }

      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          prevSlide();
          stopAutoplay();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
          stopAutoplay();
        }
      });

      updateStack(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail.variant
    if (!variant) return

    const priceElements = document.querySelectorAll('[data-product-price]')
    priceElements.forEach(el => {
      const current = el.querySelector('.product-price__current')
      const compare = el.querySelector('.product-price__compare')
      const badge = el.querySelector('.product-price__badge')

      if (current) {
        current.textContent = new Intl.NumberFormat('{{ request.locale.iso_code }}', {
          style: 'currency',
          currency: '{{ cart.currency.iso_code }}'
        }).format(variant.price / 100)
      }

      if (compare && badge) {
        if (variant.compare_at_price > variant.price) {
          compare.textContent = new Intl.NumberFormat('{{ request.locale.iso_code }}', {
            style: 'currency',
            currency: '{{ cart.currency.iso_code }}'
          }).format(variant.compare_at_price / 100)
          compare.style.display = 'inline'
          badge.style.display = 'inline-flex'

           const savings = variant.compare_at_price - variant.price
           const percentage = Math.round((savings / variant.compare_at_price) * 100)
           const saveText = badge.dataset.saveText || 'Save {{ percent }}%'
           badge.textContent = saveText.replace('{{ percent }}', percentage)
        } else {
          compare.style.display = 'none'
          badge.style.display = 'none'
        }
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-index"]) return;
  try {
    
  (function() {
    const index = document.querySelector('[data-recipe-index]');
    if (!index) return;

    const filterSelect = index.querySelector('[data-filter-select]');
    const pagination = index.querySelector('[data-recipe-pagination]');
    const grid = index.querySelector('[data-recipe-grid]');
    const sentinel = index.querySelector('[data-sentinel]');

    if (filterSelect) {
      filterSelect.addEventListener('change', (e) => {
        window.location.href = e.target.value;
      });
    }

    if (!pagination || !sentinel) return;

    const loadMoreBtn = pagination.querySelector('[data-load-more]');
    let loading = false;

    function loadNextPage() {
      if (loading) return;
      loading = true;
      observer.disconnect();
      pagination.classList.add('is-loading');

      const nextUrl = loadMoreBtn.getAttribute('href');

      fetch(nextUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newIndex = doc.querySelector('[data-recipe-index]');
          if (!newIndex) return;

          const newGrid = newIndex.querySelector('[data-recipe-grid]');
          if (newGrid) {
            const newItems = newGrid.querySelectorAll('[data-recipe-item]');
            newItems.forEach(function (item, i) {
              item.style.setProperty('--anim-delay', (i * 0.1) + 's');
              grid.appendChild(item);
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  item.classList.add('animate-visible');
                });
              });
            });
          }

          const newPagination = newIndex.querySelector('[data-recipe-pagination]');
          const newLoadMore = newPagination ? newPagination.querySelector('[data-load-more]') : null;

          if (newLoadMore) {
            loadMoreBtn.setAttribute('href', newLoadMore.getAttribute('href'));
            observer.observe(sentinel);
          } else {
            pagination.classList.add('is-hidden');
            sentinel.remove();
          }

          loading = false;
          pagination.classList.remove('is-loading');
        })
        .catch(() => {
          loading = false;
          pagination.classList.remove('is-loading');
          observer.observe(sentinel);
        });
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, { rootMargin: '400px' });

    observer.observe(sentinel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          fetch(`${this.dataset.url}&product_id=${this.dataset.productId}`)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim()) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
              this.innerHTML = '<p class="related-products__error">Unable to load recommendations.</p>';
            });
        };
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[data-product-videos]');

    sections.forEach(section => {
      const cards = section.querySelectorAll('[data-card]');
      const dots = section.querySelectorAll('[data-dot]');
      const prevBtn = section.querySelector('[data-prev]');
      const nextBtn = section.querySelector('[data-next]');
      const facades = section.querySelectorAll('[data-facade]');

      if (cards.length === 0) return;

      let currentIndex = 0;
      let autoplayInterval = null;
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) * 1000;

      function resetCardMedia(card) {
        const videoContainer = card.querySelector('.product-videos__video');
        if (!videoContainer) return;

        const liveMedia = videoContainer.querySelector('iframe, video');
        if (!liveMedia) return;

        liveMedia.remove();

        const template = videoContainer.querySelector('template');
        if (!template) return;

        const type = liveMedia.tagName === 'IFRAME' ? 'youtube' : 'shopify';
        const videoId = type === 'youtube'
          ? liveMedia.src.split('/embed/')[1]?.split('?')[0] || ''
          : '';

        const facade = document.createElement('div');
        facade.className = 'product-videos__facade';
        facade.dataset.facade = '';
        facade.dataset.type = type;
        if (videoId) facade.dataset.videoId = videoId;

        const cardIndex = parseInt(card.dataset.card, 10);
        const cached = section._facadeHTML[cardIndex];
        if (cached) {
          facade.innerHTML = cached;
        }

        facade.style.cursor = 'pointer';
        videoContainer.insertBefore(facade, template);

        facade.addEventListener('click', function handler(e) {
          e.stopPropagation();
          const ci = parseInt(facade.closest('[data-card]').dataset.card, 10);
          if (ci === currentIndex) {
            handleFacadeClick(facade);
            stopAutoplay();
          }
        });
      }

      section._facadeHTML = {};
      cards.forEach((card, i) => {
        const facade = card.querySelector('[data-facade]');
        if (facade) {
          section._facadeHTML[i] = facade.innerHTML;
        }
      });

      function updateStack(activeIndex) {
        if (activeIndex !== currentIndex && currentIndex >= 0 && currentIndex < cards.length) {
          resetCardMedia(cards[currentIndex]);
        }

        cards.forEach((card, i) => {
          const relativeIndex = (i - activeIndex + cards.length) % cards.length;
          card.classList.remove('product-videos__card--active');
          card.setAttribute('aria-hidden', 'true');

          if (relativeIndex === 0) {
            card.style.zIndex = 3;
            card.style.transform = 'translateX(0) scale(1)';
            card.style.filter = 'brightness(1)';
            card.classList.add('product-videos__card--active');
            card.setAttribute('aria-hidden', 'false');
          } else if (relativeIndex === 1) {
            card.style.zIndex = 2;
            card.style.transform = 'translateX(60px) scale(0.92)';
            card.style.filter = 'brightness(0.7)';
          } else if (relativeIndex === 2) {
            card.style.zIndex = 1;
            card.style.transform = 'translateX(120px) scale(0.84)';
            card.style.filter = 'brightness(0.5)';
          } else {
            card.style.zIndex = 0;
            card.style.transform = 'translateX(160px) scale(0.76)';
            card.style.filter = 'brightness(0.3)';
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('product-videos__dot--active', i === activeIndex);
        });

        currentIndex = activeIndex;
      }

      function goToSlide(index) {
        if (index < 0) index = cards.length - 1;
        if (index >= cards.length) index = 0;
        updateStack(index);
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (autoplayInterval) return;
        autoplayInterval = setInterval(nextSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function handleFacadeClick(facade) {
        const type = facade.dataset.type;
        const template = facade.nextElementSibling;

        if (!template || template.tagName !== 'TEMPLATE') return;

        const content = template.content.cloneNode(true);

        if (type === 'youtube') {
          const iframe = content.querySelector('iframe');
          if (iframe) {
            facade.replaceWith(iframe);
          }
        } else if (type === 'shopify') {
          const video = content.querySelector('video');
          if (video) {
            facade.replaceWith(video);
          }
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prevSlide();
          stopAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          stopAutoplay();
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          stopAutoplay();
        });
      });

      cards.forEach(card => {
        card.addEventListener('click', () => {
          const cardIndex = parseInt(card.dataset.card, 10);
          if (cardIndex !== currentIndex) {
            goToSlide(cardIndex);
            stopAutoplay();
          }
        });
      });

      facades.forEach(facade => {
        facade.addEventListener('click', (e) => {
          e.stopPropagation();
          const card = facade.closest('[data-card]');
          const cardIndex = parseInt(card.dataset.card, 10);
          if (cardIndex === currentIndex) {
            handleFacadeClick(facade);
            stopAutoplay();
          }
        });
      });

      if (autoplay && cards.length > 1) {
        startAutoplay();

        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('focusin', stopAutoplay);
        section.addEventListener('mouseleave', () => {
          if (!section.matches(':hover')) {
            startAutoplay();
          }
        });
      }

      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          prevSlide();
          stopAutoplay();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
          stopAutoplay();
        }
      });

      updateStack(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
